export default __webpack_public_path__ + "static/media/floating.85b02518.jpg";